import { getSettingsUrl } from 'vl-common/src/lib/getSettingsURL';

export const tryDeriveEndpointName = () => new URL(getSettingsUrl()).hostname.replace(/api.*/, '');

